import { FormEventHandler, useEffect, useMemo, useRef, useState } from 'react'
import { useCreateCalc, useDeleteCalc, useGetCalcDetails, useGetCalcList, useUpdateCalc, useActivateCalc } from '../api/main'
import styled from 'styled-components'
import Table from '../components/Table'
import { theme } from '../styles/theme'
import { Main } from '../styles/layout'
import { Table_Info } from '../styles/table'
import { Button_Main } from '../components/Button'
import Pagenation from '../components/Pagenation'

type CalcPopupType = '' | 'create' | 'update'
type Weights = Record<string, number>

export const CalcPage = () => {
  const
  ref = useRef({
    units: {
      time: '',
      speed: 'km/h',
      distance: 'km',
      count: '회'
    },
    headers: [
      { value: 'calName', label: '제목' },
      { value: 'useYn', label: '사용 여부' },
      { value: 'inDtm', label: '등록일' },
      { value: 'useDtm', label: '적용일' },
      { value: 'etc', label: '비고' }
    ],
    fields: [
      { value: 'drivingTime', label: '운행 시간', unit: 'time', weight: 'drivingTimeWeight' },
      { value: 'averageSpeed', label: '평균 속도', unit: 'speed', weight: 'averageSpeedWeight' },
      { value: 'speedingStandard', label: '과속 기준', unit: 'speed', weight: '' },
      { value: 'speedingDistatnce', label: '과속 거리', unit: 'distance', weight: 'speedingDistatnceWeight' },
      { value: 'speedingTime', label: '과속 시간', unit: 'time', weight: 'speedingTimeWeight' },
      { value: 'rapidAccelerationCount', label: '급가속 횟수', unit: 'count', weight: 'rapidAccelerationCountWeight' },
      { value: 'rapidDecelerationCount', label: '급감속 횟수', unit: 'count', weight: 'rapidDecelerationCountWeight' },
      { value: 'collisionWarningCount', label: '앞차 충돌 경고 횟수', unit: 'count', weight: 'collisionWarningCountWeight' },
      { value: 'continuousDrivingTime', label: '2시간 연속 운전 시간', unit: 'time', weight: 'continuousDrivingTimeWeight' },
      { value: 'lineChangeCount', label: '차선 변경 횟수', unit: 'count', weight: 'lineChangeCountWeight' },
      { value: 'shockEventCount', label: '충격 이벤트 횟수', unit: 'count', weight: 'shockEventCountWeight' }
    ],
    getDefaultWeights(data: Weights) {
      const hasData = !!data
      return this.fields.reduce((result, item) => {
        return item.weight ? Object.assign(result, { [item.weight]: hasData ? data[item.weight] : 0 }) : result
      }, {} as Weights)
    }
  }).current,
  [listParams, setlistParams] = useState({ pageSize: 10, pageNo: 1 }),
  { data: list, refetch: refetchList } = useGetCalcList(listParams),
  [detailsParams, setDetailsParams] = useState({ id: '' }),
  { data: details, refetch: refetchDetails } = useGetCalcDetails(detailsParams),
  { mutateAsync: createCalc } = useCreateCalc(),
  { mutateAsync: updateCalc } = useUpdateCalc(),
  { mutateAsync: deleteCalc } = useDeleteCalc(),
  { mutateAsync: activateCalc } = useActivateCalc(),
  { calcPopupType, isCalcPopupOpen, isCreatePopup, setCalcPopupType, weights, totalWeight, setWeights, calcPopupDefaultName, calcPopupDefaultEtc, isInUse } = useCalcPopup(ref, details)

  const onTableClick = (calcName: string) => {
    try {
      if (typeof calcName === "string") {
        const calcId = list?.content.find((item: {calName: string}) => item.calName == calcName)?.idx
        if (calcId > 0) {
          setCalcPopupType('update')
          if (calcId !== detailsParams.id) setDetailsParams({ id: calcId })
        } 
      }
      
    } catch (e: any) {
      console.error(`onTableClick > `, e)
    }
  }

  const onWeightChange: FormEventHandler<HTMLTableElement> = (e) => {
    const { target } = e
    if (target instanceof HTMLInputElement)
      if (target.classList.contains('weight')) {
        const key = target.name,
          valueNum = Number(Number(target.value).toFixed(2)),
          cleanValue = valueNum > 1 ? 1 : valueNum < 0 ? 0 : valueNum
        target.value = cleanValue.toString()
        setWeights((prev) => ({ ...prev, [key]: cleanValue }))
      }
  }

  const onCalcSubmit: FormEventHandler<HTMLFormElement> = async ({ nativeEvent }) => {
    try {
      const e = nativeEvent as SubmitEvent
      e.preventDefault()
      if (!totalWeight.isValid) return alert('가중치의 합은 1이어야 합니다')
      const
      form = e.target as HTMLFormElement,
      formData = new FormData(form),
      body = Object.assign(Object.fromEntries(formData), isCreatePopup ? {} : { id: detailsParams.id }),
      req = isCreatePopup ? createCalc : updateCalc,
      res = await req(body)
      if (!res) return alert('실패')
      refetchDetails()
      refetchList()
      closeCalcDetails()

    } catch (e: any) {
      console.error(`onCalcSubmit > `, e)
    }
  }

  const onUseCalcClick = async () => {
    try {
      const detailsId = details?.safeCaleDetailRes.id
      const inUse = details?.safeCaleDetailRes.useYn === 'Y'
      if (!detailsId && inUse) return closeCalcDetails()
      
      if (window.confirm("기존의 안전운행점수 데이터가 모두 삭제됩니다. 그래도 진행하시겠 습니까?")) {
        const res = await activateCalc({id: detailsId})
        if (res) {
          refetchDetails()
          refetchList()
          closeCalcDetails()
        } else {
          window.alert("API 실패")
        }
      }

    } catch (e: any) {
      console.error(`onUseCalcClick > `, e)
    }
  }

  const onDeleteCalcClick = async () => {
    try {
      const detailsId = details?.safeCaleDetailRes.id
      if (!detailsId) return closeCalcDetails()
      const res = await deleteCalc({ id: detailsId })
      if (!res) return alert('실패')
      setDetailsParams({ id: '' })
      refetchDetails()
      refetchList()
      closeCalcDetails()

    } catch (e: any) {
      console.error(`onDeleteCalcClick > `, e)
      if (e.response?.data?.message === 'check useYn') return alert('적용중인 기준표는 삭제할 수 없습니다')
    }
  }

  const openCalcDetails = () => {
    if (!calcPopupType) setCalcPopupType('create')
  }

  const closeCalcDetails = () => {
    if (isCalcPopupOpen) setCalcPopupType('')
  }

  return (
    <Main>
      <h1>안전 점수 계산 기준표</h1>

      <Table_Info>
        Total Count: ?
        <Button_Main onClick={openCalcDetails}>등록</Button_Main>
      </Table_Info>

      <Table modalKey={ref.headers[0].value} headers={ref.headers} data={list?.content} rowKey={ref.headers[0].value} onClick={onTableClick} />

      <Pagenation totalPage={10} isLoading={false} />

      {isCalcPopupOpen && (
        <CalcDetails className="details" key={details}>
          <form onSubmit={onCalcSubmit}>
            <header>
              <input name="calName" defaultValue={calcPopupDefaultName} placeholder="기준표 이름" spellCheck={false} required />
              <button type="button" onClick={closeCalcDetails}>
                x
              </button>
            </header>

            <table onChange={onWeightChange}>
              <thead>
                <tr>
                  <th>항목</th>
                  <th>값</th>
                  <th>가중치</th>
                </tr>
              </thead>
              <tbody>
                {ref.fields.map(({ value, label, unit, weight }) => {
                  const _unit = ref.units[unit as keyof typeof ref.units],
                    hasWeight = !!weight,
                    defaultValue = isCreatePopup ? '' : (details?.saveCalcuDateReq[value] ?? ''),
                    defaultWeightValue = isCreatePopup ? '' : (details?.saveCalcuDateReq[weight] ?? '')
                  return (
                    <tr key={value}>
                      <td>{label}</td>
                      <td>
                        <input name={value} defaultValue={defaultValue} autoComplete="off" />
                        <span className="unit">{_unit}</span>
                      </td>
                      {hasWeight && (
                        <td>
                          <input className="weight" name={weight} defaultValue={defaultWeightValue} type="number" min="0" max="1" step="0.01" autoComplete="off" />
                        </td>
                      )}
                    </tr>
                  )
                })}
                <tr>
                  <td colSpan={3}>
                    <div className="result">
                      <label>가중치 합:</label>
                      <strong>{totalWeight.value}</strong>
                    </div>
                  </td>
                </tr>
                <tr className="etc">
                  <td colSpan={4}>
                    <input name="etc" defaultValue={calcPopupDefaultEtc} placeholder="비고" spellCheck={false} />
                  </td>
                </tr>
              </tbody>
            </table>

            <footer>
              <p className={!totalWeight.isValid ? 'red' : ''}>가중치의 합은 1이어야 합니다</p>
              <menu>
                <button disabled={!isCreatePopup && (details?.safeCaleDetailRes?.useYn === "Y")}>{isCreatePopup ? '등록' : '수정'}</button>
                {!isCreatePopup && <button className="use" type="button" onClick={onUseCalcClick} disabled={isInUse}>적용</button>}
                {!isCreatePopup && <button className="delete" type="button" onClick={onDeleteCalcClick} disabled={isInUse}>삭제</button>}
              </menu>
            </footer>
          </form>
        </CalcDetails>
      )}
    </Main>
  )
}

const useCalcPopup = (ref: any, details: any) => {
  // 팝업
  const [calcPopupType, setCalcPopupType] = useState<CalcPopupType>('')

  const { isCalcPopupOpen, isCreatePopup } = useMemo(() => {
    const result = {
      isCalcPopupOpen: !!calcPopupType,
      isCreatePopup: calcPopupType === 'create'
    }
    document.documentElement.style.overflow = result.isCalcPopupOpen ? 'hidden' : ''
    return result
  }, [calcPopupType])

  // 가중치
  const [weights, setWeights] = useState<Weights>(() => ref.getDefaultWeights())

  const totalWeight = useMemo(() => {
    const result = {
      value: 0,
      isValid: false
    }

    for (const weightLabel in weights) result.value += weights[weightLabel]

    result.value = Number(result.value.toFixed(2))
    result.isValid = result.value == 1

    return result
  }, [weights])

  useEffect(() => {
    if (calcPopupType === 'create') {
      setWeights(() => ref.getDefaultWeights())
    } else if (calcPopupType === 'update') {
      const weights: Weights = details?.saveCalcuDateReq
      if (weights) setWeights(() => ref.getDefaultWeights(weights))
    }
  }, [calcPopupType, details])

  // 이름, 비고
  const { calcPopupDefaultName, calcPopupDefaultEtc } = useMemo(() => {
    const result = {
      calcPopupDefaultName: '',
      calcPopupDefaultEtc: ''
    }
    if (!isCreatePopup) {
      result.calcPopupDefaultName = details?.safeCaleDetailRes.calName ?? ''
      result.calcPopupDefaultEtc = details?.safeCaleDetailRes.etc ?? ''
    }
    return result
  }, [isCreatePopup, details])

  // 버튼
  const { isInUse } = useMemo(() => {
    const result = {
      isInUse: false
    }

    const data = details?.safeCaleDetailRes
    if (data) {
      result.isInUse = data.useYn === 'Y'
    }

    return result
  }, [details])

  return {
    calcPopupType,
    isCalcPopupOpen,
    isCreatePopup,
    setCalcPopupType,
    weights,
    totalWeight,
    setWeights,
    calcPopupDefaultName,
    calcPopupDefaultEtc,
    isInUse
  }
}

const CalcHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 10px;
  padding-bottom: 10px;

  & > strong {
    font-size: 24px;
  }
  & > button {
    padding: 5px 15px;
    background-color: ${theme.colors.blue};
    color: ${theme.colors.white};
    font-size: 18px;
    font-weight: 600;
  }
`
const CalcDetails = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;

  & > form {
    background-color: ${theme.colors.white};
    padding: 20px;

    & > header {
      display: flex;
      justify-content: space-between;
      align-items: start;
      padding-bottom: 10px;

      & > input {
        font-size: 18px;
        font-weight: 600;
        border: none;
        padding: 5px;
        &::placeholder {
          color: silver;
        }
        &:active {
          background-color: whitesmoke;
        }
      }
      & > button {
        font-size: 20px;
        background-color: ${theme.colors.black};
        color: ${theme.colors.white};
        width: 24px;
        height: 24px;
      }
    }
    & > table {
      & tr {
        border: 1px solid ${theme.colors.graybd};
        height: 40px;
      }
      & td,
      th {
        padding: 0 10px;
        font-size: 14px;

        & > .unit {
          margin-left: 5px;
        }
        & > .result {
          display: flex;
          justify-content: end;
          gap: 10px;

          & > strong {
            font-weight: 600;
            letter-spacing: 1px;
          }
        }
      }
      & .etc {
        & > td {
          padding: 0;

          & > input {
            border: none;
            text-align: start;
            width: 100%;
            padding: 0 10px;
          }
        }
      }
      & input {
        height: 30px;
        border: 1px solid ${theme.colors.graybd};
        width: 150px;
        text-align: center;

        &.weight {
          width: 100px;
        }
      }
      & * {
        white-space: nowrap;
      }
      & > thead {
        & > tr {
          height: 34px;
          background-color: ${theme.colors.black};
          color: ${theme.colors.white};
          border-color: ${theme.colors.black};
        }
      }
    }
    & > footer {
      display: grid;

      & > p {
        display: flex;
        justify-content: center;
        align-items: end;
        text-align: center;
        padding: 10px;
        font-size: 14px;
        min-height: 60px;

        &.red {
          color: ${theme.colors.red};
        }
      }
      & > menu {
        display: grid;
        grid-auto-flow: column;
        gap: 10px;

        & > button {
          background-color: ${theme.colors.blue};
          color: ${theme.colors.white};
          padding: 10px;
          font-size: 18px;
          font-weight: 700;

          &.use {
            background-color: ${theme.colors.green};
          }
          &.delete {
            background-color: ${theme.colors.red};
          }
          &:disabled {
            background-color: ${theme.colors.disabled};
          }
        }
      }
    }
  }
`